module.exports = __webpack_public_path__ + "3537c9049c00af0f00f4035a8f90b76f.png";